import { useIntl } from 'react-intl';

import { CmsBanner, CmsBannerType } from '../../../../common/cms-banner';
import { useGetBanners } from '../../../../../hooks/use-get-banners';
import { Preloader } from '../../../../common/preloader';
import { useStyles } from './sign-up-banner.styles';
import { useDayPeriod } from './use-day-period';

const bannerTypes = {
  morning: CmsBannerType.morningBanner,
  afternoon: CmsBannerType.dayBanner,
  evening: CmsBannerType.nightBanner,
};

export const SignUpBanner = (): JSX.Element => {
  const bannerType = bannerTypes[useDayPeriod()];
  const { isBanner, url, loading, pwaCallToActionLink } = useGetBanners(bannerType);
  const classes = useStyles();
  const intl = useIntl();

  if (loading) {
    return <Preloader />;
  }

  return (
    <>
      {isBanner && (
        <section data-testid="slide" className={classes.root} aria-label={intl.formatMessage({ id: 'signUpBanner.title' })}>
            <CmsBanner
              url={url}
              pwaCallToActionLink={pwaCallToActionLink}
            />
        </section>
      )}
    </>
  );
};
